import { useMutation, useQuery } from "@tanstack/react-query";
import {
  checkMedisendOtp,
  syncMedisend,
} from "../../../services/syncAccountApi";
import { useEffect, useState } from "react";
import { Box, CircularProgress, Modal } from "@mui/material";
import { RxCross1 } from "react-icons/rx";
import LoadingBackdrop from "../../common/particles.jsx/LoadingBackdrop";
import ErrorPopup from "../../common/particles.jsx/ErrorPopup";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

const MedisendOtpModal = ({ open, setOpen }) => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleClose = () => {
    setOtp(["", "", "", "", "", ""]);
    setErrorMessage("");
    setSuccessMessage("");
    setOpen(false);
  };

  const handleInputOtp = (e, index) => {
    const newString = [
      ...otp.slice(0, index),
      !isNaN(Number(e.target.value))
        ? e.target.value.length === 1
          ? Number(e.target.value)
          : e.target.value.length === 0
          ? ""
          : ""
        : "",
      ...otp.slice(index + 1),
    ];

    setOtp(newString);
    setErrorMessage("");

    if (e.target.value.length === 1 && e.target.nextElementSibling) {
      e.target.nextElementSibling.focus();
    }
    if (e.target.value.length === 0 && e.target.previousElementSibling) {
      e.target.previousElementSibling.focus();
    }

    if (!newString.includes("")) {
      mutateOtp({ otp: newString.join("") });
    }
  };

  const {
    data: dataSync,
    isFetching: isFetchingSync,
    refetch: refetchSync,
  } = useQuery({
    queryKey: ["sync-medisend"],
    queryFn: () => syncMedisend(),
    enabled: false,
  });

  const { mutate: mutateOtp, isLoading: isLoadingOtp } = useMutation({
    mutationFn: checkMedisendOtp,
    onError: (err) =>
      setErrorMessage(
        err.message?.id ? err.message.id : err.message ? err.message : err
      ),
    onSuccess: () => {
      refetchSync();
      handleClose();
    },
  });

  useEffect(() => {
    if (dataSync && !isFetchingSync)
      setSuccessMessage("Produk berhasil di sync!");
  }, [dataSync]);

  return (
    <>
      <LoadingBackdrop isLoading={isFetchingSync} />
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            ...style,
            maxWidth: "75%",
            overflowY: "hidden",
            overflowX: "wrap",
            maxHeight: "80vh",
            padding: 0,
          }}
          className="text-left text-[12px] w-3/4 lg:w-2/3 h-fit text-[#2C3E5D]"
        >
          <div className="flex justify-between items-center px-8 py-4">
            <p className="text-[18px]">Masukan OTP</p>
            <RxCross1
              className="cursor-pointer hover:text-red-500"
              onClick={handleClose}
            />
          </div>

          <hr />

          {isLoadingOtp | isFetchingSync ? (
            <div className="px-8 py-4 flex items-center justify-center">
              <CircularProgress size={20} />
            </div>
          ) : (
            <div className="px-8 py-4 text-center">
              <p className="mb-2">Silahkan masukan OTP yang sudah dikirimkan</p>
              <div className="flex justify-center gap-2 mb-2">
                <input
                  maxLength={1}
                  value={otp[0]}
                  onInput={(e) => {
                    handleInputOtp(e, 0);
                  }}
                  className={`border-2 h-[80px] w-[80px] text-center rounded-lg text-[20px] ${
                    errorMessage !== ""
                      ? "border-red-500 focus:border-red-500 focus:outline-none focus:ring-0"
                      : ""
                  }`}
                  disabled={isLoadingOtp}
                />
                <input
                  maxLength={1}
                  value={otp[1]}
                  onInput={(e) => {
                    handleInputOtp(e, 1);
                  }}
                  className={`border-2 h-[80px] w-[80px] text-center rounded-lg text-[20px] ${
                    errorMessage !== ""
                      ? "border-red-500 focus:border-red-500 focus:outline-none focus:ring-0"
                      : ""
                  }`}
                  disabled={isLoadingOtp}
                />
                <input
                  maxLength={1}
                  value={otp[2]}
                  onInput={(e) => {
                    handleInputOtp(e, 2);
                  }}
                  className={`border-2 h-[80px] w-[80px] text-center rounded-lg text-[20px] ${
                    errorMessage !== ""
                      ? "border-red-500 focus:border-red-500 focus:outline-none focus:ring-0"
                      : ""
                  }`}
                  disabled={isLoadingOtp}
                />
                <input
                  maxLength={1}
                  value={otp[3]}
                  onInput={(e) => {
                    handleInputOtp(e, 3);
                  }}
                  className={`border-2 h-[80px] w-[80px] text-center rounded-lg text-[20px] ${
                    errorMessage !== ""
                      ? "border-red-500 focus:border-red-500 focus:outline-none focus:ring-0"
                      : ""
                  }`}
                  disabled={isLoadingOtp}
                />
                <input
                  maxLength={1}
                  value={otp[4]}
                  onInput={(e) => {
                    handleInputOtp(e, 4);
                  }}
                  className={`border-2 h-[80px] w-[80px] text-center rounded-lg text-[20px] ${
                    errorMessage !== ""
                      ? "border-red-500 focus:border-red-500 focus:outline-none focus:ring-0"
                      : ""
                  }`}
                  disabled={isLoadingOtp}
                />
                <input
                  maxLength={1}
                  value={otp[5]}
                  onInput={(e) => {
                    handleInputOtp(e, 5);
                  }}
                  className={`border-2 h-[80px] w-[80px] text-center rounded-lg text-[20px] ${
                    errorMessage !== ""
                      ? "border-red-500 focus:border-red-500 focus:outline-none focus:ring-0"
                      : ""
                  }`}
                  disabled={isLoadingOtp}
                />
              </div>
              <p className="text-red-500">{errorMessage}</p>
            </div>
          )}
        </Box>
      </Modal>
      <ErrorPopup
        errorMessage={successMessage}
        setErrorMessage={setSuccessMessage}
      />
    </>
  );
};

export default MedisendOtpModal;
